import {useEffect, useState} from "react";
import {findSmartLockPermissionsWithPagination} from "../api/smartLockPermissionApiClient";

export const useSmartLockPermissions = (page, pageSize, reloadTrigger) => {
    const [customerSmartLockPermissions, setCustomerSmartLockPermissions] = useState([]);
    const [pagination, setPagination] = useState(null);

    useEffect(() => {
        const abortController = new AbortController();
        const smartLockPermissionsWithPagination = findSmartLockPermissionsWithPagination(page, pageSize, abortController.signal);

        smartLockPermissionsWithPagination
            .then(
                (data) => {
                    const customerSmartLockPermissions = data.customerSmartLockPermissions;
                    const pagination = data.pagination;

                    setCustomerSmartLockPermissions(customerSmartLockPermissions)
                    setPagination(pagination)
                }
            )
            .catch(
                (error) => console.log(error)
            );

        return () => {
            abortController.abort();
        };
    }, [page, pageSize, reloadTrigger]);

    return {customerSmartLockPermissions : customerSmartLockPermissions, pagination};
};
